import type {
  GetListResponseOfNexusInFlightResponse,
  NexusGraphRequest,
  NexusGraphResponse,
  NexusInFlightRequest,
} from 'src/api/ProactApiClient';
import {workflowNexusApiClient} from 'src/api/ProactApiClientInstances';
import {clientQuery} from '../clientQuery';
import {emptySplitApi} from '../api';

export const workflowNexusApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getNexusGraph: builder.query<NexusGraphResponse, NexusGraphRequest>({
      queryFn: clientQuery(params => workflowNexusApiClient.graph(params)),
      providesTags: ['Workflows'],
    }),
    getNexusInFlight: builder.query<
      GetListResponseOfNexusInFlightResponse,
      NexusInFlightRequest
    >({
      queryFn: clientQuery(params => workflowNexusApiClient.inFlight(params)),
      providesTags: ['Workflows'],
    }),
  }),
});

export const {
  useGetNexusGraphQuery,
  useGetNexusInFlightQuery,
  useLazyGetNexusGraphQuery,
} = workflowNexusApi;
